import { Box, Link, Typography, styled } from "@mui/material";

const StyledTypography = styled(Typography)(() => ({
  cursor: "pointer",
  transition: "text-decoration 0.3s ease",
  "&:hover": {
    textDecoration: "line-through",
  },
}));

export default function ContactPage() {
  const handleEmailClick = () => {
    window.location.href = "mailto:chebanenkopolina@gmail.com";
  };
  return (
    <section
      id="contact"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box width={{ xs: "100%", md: "50vw" }}>
        <Typography variant="h1" sx={{ fontSize: { xs: "7rem", md: "192px" } }}>
          Hello.
        </Typography>
        <Box ml={1}>
          <Typography variant="body2" fontFamily="Aktiv" mt={2}>
            Reach out if you have an idea that has been keeping you up at night.
          </Typography>
          <Typography variant="body2">
            Or if you have an idea that will keep me awake at night.
          </Typography>
          <Box display="flex" alignItems="center" mt={4}>
            <Typography variant="body2" mr={1}>
              Email:
            </Typography>
            <StyledTypography variant="body2" onClick={handleEmailClick}>
              polinachebanenko@gmail.com
            </StyledTypography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="body2" mr={1}>
              Out there:
            </Typography>
            <Box>
              <Link
                href="https://www.linkedin.com/in/polinachebanenko/"
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
                mr={2}
              >
                LINKEDIN
              </Link>
              <Link
                href="https://github.com/apoolinaria"
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
              >
                GITHUB
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </section>
  );
}
